<template>
    <DModal
        v-model:show="createRoleModalVisible"
        :title="__('users.role.modal.title')"
        is-confirm
        :confirm-button-text="__('users.role.modal.create')"
        is-big
        @confirm="confirmRole"
    >
        <DCard
            padding
        >
            <DFormRow
                :label="__('users.role.modal.select_label')"
                :hint="__('users.role.modal.hint')"
            >
                <DSelect
                    id="date"
                    :placeholder="__('users.role.modal.select_label')"
                    add-label-classes="required"
                    :options="roleOptionsProp"
                    @update:value="updateSelectedRole"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script>
export default {
    name: 'CreateRoleModal',
    props: {
        roleOptionsProp: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['confirmRole'],
    methods: {
        updateSelectedRole (value) {
            this.role = value
        },
        confirmRole () {
            this.$emit('confirmRole', this.role)
        }
    }
}
</script>

<style scoped lang="scss">

</style>
